// точки перевязки
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CRow,
  CCol,
  CTable,
  CTableBody,
  CTableRow,
  CTableDataCell,
  CButton,
  CTableHead,
  CTableHeaderCell,
} from "@coreui/react";
import PropTypes from 'prop-types';

const BindingPointsModal = ({
  visible,
  onClose,
  onSave,
  onBindingSaved, // <-- Принимаем проп
  stationOne,
  stationTwo,
}) => {
  const [leftExpanded, setLeftExpanded] = useState(false);
  const [rightExpanded, setRightExpanded] = useState(false);

  const [leftPoints, setLeftPoints] = useState([]);
  const [rightPoints, setRightPoints] = useState([]);

  const [selectedLeftPoint, setSelectedLeftPoint] = useState(null);
  const [selectedRightPoint, setSelectedRightPoint] = useState(null);

  const fetchPoints = async (idStation) => {
    try {
      const response = await axios.get(`/api/protocols/source/?idStation=${idStation}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      console.log(`Данные с сервера для станции ${idStation}:`, response.data);

      const uniqueMarks = new Set();
      const uniquePoints = [];

      for (const point of response.data) {
        if (!uniqueMarks.has(point.PointMark)) {
          uniqueMarks.add(point.PointMark);
          uniquePoints.push(point.PointMark);
        }
      }

      return uniquePoints;
    } catch (error) {
      console.error(`Ошибка загрузки точек для станции ${idStation}:`, error);
      return [];
    }
  };

  useEffect(() => {
    if (visible && stationOne) {
      fetchPoints(stationOne.id).then((points) => {
        setLeftPoints(points);
        setSelectedLeftPoint(null);
      });
    }
    if (visible && stationTwo) {
      fetchPoints(stationTwo.id).then((points) => {
        setRightPoints(points);
        setSelectedRightPoint(null);
      });
    }
  }, [visible, stationOne, stationTwo]);

  const handleSave = async () => {
    const token = localStorage.getItem("token");

    const leftPayload = {
      Id: stationOne.id,
      IsRotate: leftExpanded ? 1 : 0,
    };

    const rightPayload = {
      Id: stationTwo.id,
      DressPoint: selectedRightPoint,
      IsRotate: rightExpanded ? 1 : 0,
      idParent: stationOne.id,
    };

    console.log("➡️ Отправка данных для левой стоянки:", leftPayload);
    console.log("➡️ Отправка данных для правой стоянки:", rightPayload);

    try {
      const leftResponse = await axios.put(
        "/api/protocols/station/",
        leftPayload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("✅ Ответ от сервера для левой стоянки:", leftResponse.data);

      const rightResponse = await axios.put(
        "/api/protocols/station/",
        rightPayload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("✅ Ответ от сервера для правой стоянки:", rightResponse.data);

      // Вызываем onSave из пропсов (если он есть)
      if (onSave) {
        onSave({
          left: {
            id: stationOne.id,
            expanded: leftExpanded,
            selectedPoint: selectedLeftPoint,
          },
          right: {
            id: stationTwo.id,
            expanded: rightExpanded,
            selectedPoint: selectedRightPoint,
          },
        });
      }
      if (onBindingSaved) {
        onBindingSaved(); // <-- Это перезагрузит stationsList в ProtocolVerticality
      }

      onClose(); // Закрываем модальное окно
    } catch (error) {
      console.error("❌ Ошибка при сохранении точек перевязки:", error);

      if (error.response) {
        console.error("Ответ сервера:", error.response.data);
      }
      alert("Не удалось сохранить точки перевязки. Проверьте консоль.");
    }
  };

  return (
    <CModal visible={visible} onClose={onClose} size="lg">
      <CModalHeader>
        <CModalTitle>Укажите точки перевязки стоянок</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CRow>
          {/* Левая таблица */}
          <CCol md="6">
            <h6>Стоянка №{stationOne?.number}</h6>
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id={`left-expand-${stationOne?.id}`}
                checked={leftExpanded}
                onChange={(e) => setLeftExpanded(e.target.checked)}
              />
              <label className="form-check-label" htmlFor={`left-expand-${stationOne?.id}`}>
                Развернуть стоянку
              </label>
            </div>

            <CTable bordered hover responsive>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell className="text-center">Отметка, м</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {leftPoints.length > 0 ? (
                  leftPoints.map((point, index) => (
                    <CTableRow
                      key={index}
                      onClick={() => setSelectedLeftPoint(point)}
                      style={{ cursor: "pointer" }}
                    >
                      <CTableDataCell
                        className="text-center"
                        style={{
                          backgroundColor: selectedLeftPoint === point ? "#66A7F2" : "",
                        }}
                      >
                        {point}
                      </CTableDataCell>
                    </CTableRow>
                  ))
                ) : (
                  <CTableRow>
                    <CTableDataCell className="text-center" colSpan={1}>
                      Нет данных
                    </CTableDataCell>
                  </CTableRow>
                )}
              </CTableBody>
            </CTable>
          </CCol>

          {/* Правая таблица */}
          <CCol md="6">
            <h6>Стоянка №{stationTwo?.number}</h6>
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id={`right-expand-${stationTwo?.id}`}
                checked={rightExpanded}
                onChange={(e) => setRightExpanded(e.target.checked)}
              />
              <label className="form-check-label" htmlFor={`right-expand-${stationTwo?.id}`}>
                Развернуть стоянку
              </label>
            </div>

            <CTable bordered hover responsive>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell className="text-center">Отметка, м</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {rightPoints.length > 0 ? (
                  rightPoints.map((point, index) => (
                    <CTableRow
                      key={index}
                      onClick={() => setSelectedRightPoint(point)}
                      style={{ cursor: "pointer" }}
                    >
                      <CTableDataCell
                        className="text-center"
                        style={{
                          backgroundColor: selectedRightPoint === point ? "#66A7F2" : "",
                        }}
                      >
                        {point}
                      </CTableDataCell>
                    </CTableRow>
                  ))
                ) : (
                  <CTableRow>
                    <CTableDataCell className="text-center" colSpan={1}>
                      Нет данных
                    </CTableDataCell>
                  </CTableRow>
                )}
              </CTableBody>
            </CTable>
          </CCol>
        </CRow>

        <p className="text-center text-muted mt-2">
          *Выберите начальную/конечную отметку у каждой стоянки
        </p>

        <div className="d-flex justify-content-end gap-3 mt-3">
          <CButton color="secondary" onClick={onClose}>
            Отменить
          </CButton>
          <CButton
            color="success"
            onClick={handleSave}
            disabled={!selectedLeftPoint || !selectedRightPoint}
          >
            Сохранить
          </CButton>
        </div>
      </CModalBody>
    </CModal>
  );
};

export default BindingPointsModal;

BindingPointsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  onBindingSaved: PropTypes.func, // <-- Добавлено в PropTypes
  stationOne: PropTypes.shape({
    id: PropTypes.number.isRequired,
    number: PropTypes.number.isRequired,
  }),
  stationTwo: PropTypes.shape({
    id: PropTypes.number.isRequired,
    number: PropTypes.number.isRequired,
  }),
};

BindingPointsModal.defaultProps = {
  onSave: () => {},
  onBindingSaved: () => {}, // <-- Добавлено в defaultProps
  stationOne: null,
  stationTwo: null,
};